import styled from '@emotion/styled';
import AssignmentTurnedInOutlined from '@mui/icons-material/AssignmentTurnedInOutlined';
import { Fab, GlobalStyles, Tooltip } from '@mui/material';
import React from 'react';

import {
  DesignToken,
  type DesignTokenSet,
} from '~/client/components/base/core';

const FAB_OFFSET_PX = 28;
const FAB_SIZE_PX = 56;

/** Space the page keeps below its content while the button shows, so the last controls can scroll clear of it. */
export const FLOATING_TASK_CLEARANCE = `${FAB_OFFSET_PX + FAB_SIZE_PX + 16}px`;

const StyledFab = styled(Fab)<{ tokens?: DesignTokenSet }>`
  position: fixed;
  bottom: ${FAB_OFFSET_PX}px;
  right: ${FAB_OFFSET_PX}px;
  z-index: 1300;
  background-color: ${(props) => (props.tokens ?? DesignToken).status.danger};
  color: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
  animation: floatPulse 2.4s ease-in-out infinite;

  &:hover {
    background-color: ${(props) => (props.tokens ?? DesignToken).status.danger};
    transform: scale(1.08);
  }

  @keyframes floatPulse {
    0% {
      box-shadow:
        0 6px 18px rgba(0, 0, 0, 0.28),
        0 0 0 0 ${(props) => (props.tokens ?? DesignToken).status.danger}66;
    }
    70% {
      box-shadow:
        0 6px 18px rgba(0, 0, 0, 0.28),
        0 0 0 12px ${(props) => (props.tokens ?? DesignToken).status.danger}00;
    }
    100% {
      box-shadow:
        0 6px 18px rgba(0, 0, 0, 0.28),
        0 0 0 0 ${(props) => (props.tokens ?? DesignToken).status.danger}00;
    }
  }
`;

interface Props {
  tokens?: DesignTokenSet;
  onClick: () => void;
}

export const FloatingTaskFab: React.FC<Props> = ({ tokens, onClick }) => (
  <>
    <GlobalStyles
      styles={{
        ':root': { '--floating-task-clearance': FLOATING_TASK_CLEARANCE },
      }}
    />
    <Tooltip title="You have tasks to review" placement="left" arrow>
      <StyledFab
        tokens={tokens}
        aria-label="Review pending tasks"
        onClick={onClick}
      >
        <AssignmentTurnedInOutlined />
      </StyledFab>
    </Tooltip>
  </>
);
